import React from 'react';
import BaechaList2 from "../containers/BaechaList2/BaechaList2";

const BaechaListPage2: React.FC = () => <BaechaList2 />;

export default BaechaListPage2;
